import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {ListItemIcon, ListItemText, Menu, MenuItem} from '@mui/material'
import {getOcAppBarHmiStudioSubMenuActions} from './OcAppBarHmiStudioSubMenuActions'
import {makeOcStyles} from '@oc/styles'

const useOCAppBarMenuStyles = makeOcStyles(theme => ({
    rootDiv: {
        display: 'flex',
        alignItems: 'center'
    },
    menu: {
        paddingTop: 0.1
    },
    menuIcon: {
        minWidth: theme.spacing(4)
    },
    menuItem: {
        paddingLeft: theme.spacing(3),
        color: theme.syskronPalette.colors.P700
    }
}))

interface OcAppBarHmiStudioSubMenuProps {
    anchorHmiStudioEl: Element | null
    setAnchorHmiStudioEl: React.Dispatch<React.SetStateAction<Element | null>>
    handleCloseAppBarMenu: () => void
}

function _OcAppBarHmiStudioSubMenu({
    anchorHmiStudioEl,
    setAnchorHmiStudioEl,
    handleCloseAppBarMenu
}: OcAppBarHmiStudioSubMenuProps) {
    const {classes} = useOCAppBarMenuStyles()

    const handleClose = React.useCallback(() => {
        setAnchorHmiStudioEl(null)
        handleCloseAppBarMenu()
    }, [handleCloseAppBarMenu, setAnchorHmiStudioEl])

    const ocAppBarHmiStudioSubMenuActions = getOcAppBarHmiStudioSubMenuActions(handleClose)

    return (
        <div className={classes.rootDiv}>
            <Menu
                id="oc-app-bar-hmi-studio-sub-menu"
                anchorEl={anchorHmiStudioEl}
                autoFocus={false}
                open={Boolean(anchorHmiStudioEl)}
                onClose={handleClose}
                classes={{list: classes.menu}}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'right'
                }}
            >
                {ocAppBarHmiStudioSubMenuActions.map(value => (
                    <MenuItem
                        disabled={value.disabled}
                        key={value.id}
                        onClick={value.onClick}
                        data-cy={`app-bar-hmi-studio-sub-menu-${value.id}`}
                    >
                        <ListItemIcon className={classes.menuIcon}>{value.ocIcon}</ListItemIcon>
                        <ListItemText className={classes.menuItem}>{value.text}</ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    )
}

export const OcAppBarHmiStudioSubMenu = observer(_OcAppBarHmiStudioSubMenu)
